import styled from "styled-components";

export const YearViewDiv = styled.div`
    padding: 1rem;
    // background: yellow;
`;
